import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, getSpacing, gradientText, typography } from 'stylesheet';
import { Close, Delete } from 'theme/icons';
var Title = styled.h1.withConfig({
  displayName: "SlideshowEmbedDialogstyle__Title",
  componentId: "sc-1hu9icw-0"
})(["", " ", ""], typography.h1, gradientText);
var CloseButton = styled(Close).withConfig({
  displayName: "SlideshowEmbedDialogstyle__CloseButton",
  componentId: "sc-1hu9icw-1"
})(["position:absolute;right:", ";cursor:pointer;& path{fill:", ";}"], getSpacing(3), colorUsage.textColor);
var Description = styled.p.withConfig({
  displayName: "SlideshowEmbedDialogstyle__Description",
  componentId: "sc-1hu9icw-2"
})(["margin-top:", ";text-align:center;"], getSpacing(1));
var ButtonContainer = styled.div.withConfig({
  displayName: "SlideshowEmbedDialogstyle__ButtonContainer",
  componentId: "sc-1hu9icw-3"
})(["margin-top:", ";"], getSpacing(2));
var SearchBoxWrapper = styled.div.withConfig({
  displayName: "SlideshowEmbedDialogstyle__SearchBoxWrapper",
  componentId: "sc-1hu9icw-4"
})(["margin:", ";"], getSpacing(2));
var DeleteContentButton = styled(Delete).withConfig({
  displayName: "SlideshowEmbedDialogstyle__DeleteContentButton",
  componentId: "sc-1hu9icw-5"
})(["position:absolute;top:-", ";right:-", ";display:none;border:2px solid ", ";border-radius:", ";cursor:pointer;& circle{fill:", ";}"], getSpacing(1), getSpacing(1), colorUsage.imageDeleteButtonBorder, borderRadius.medium, colorUsage.imageDeleteButtonBackground);
var SelectedContentContainer = styled.div.withConfig({
  displayName: "SlideshowEmbedDialogstyle__SelectedContentContainer",
  componentId: "sc-1hu9icw-6"
})(["position:relative;display:flex;flex-direction:column;align-items:flex-start;width:100%;margin:", ";&:hover{", "{display:block;}}"], getSpacing(2), DeleteContentButton);
var Img = styled.img.withConfig({
  displayName: "SlideshowEmbedDialogstyle__Img",
  componentId: "sc-1hu9icw-7"
})(["max-width:100%;height:auto;border-radius:", ";"], borderRadius.large);
var Label = styled.p.withConfig({
  displayName: "SlideshowEmbedDialogstyle__Label",
  componentId: "sc-1hu9icw-8"
})(["margin:", " auto;font-size:", ";text-align:center;"], getSpacing(2), fontSize.large);
export { ButtonContainer, CloseButton, DeleteContentButton, Description, Img, Label, SearchBoxWrapper, SelectedContentContainer, Title };